export default {
    DIRECT: 1,
    ONE_STOP: 2,
    MULTI_STOP: 3,
    ALL: 0,
};



// WEBPACK FOOTER //
// ./src/app/modules/flights/flight-stop-types.js